// Primeiro segmento do caminho que NÃO é alias de clínica: nomes de página do roteador que
// podem aparecer na URL sem ?page= (ex.: /login). Tratados como "sem alias" na tela de login.
const RESERVED_PATH_SEGMENTS = new Set(["login", "landing"]);

export const isReservedPathSegment = (segment: string | null | undefined): boolean =>
  !!segment && RESERVED_PATH_SEGMENTS.has(segment.trim().toLowerCase());
